import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SummaryForm from './components/SummaryForm';
import Header from './components/Header';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import { AuthProvider } from './components/AuthProvider';
import { ToastProvider } from './components/ToastProvider';
import PasswordProtection from './components/PasswordProtection';
import SkipLink from './components/SkipLink';
import './i18n';
import './styles/accessibility.css';

function AppContent() {
  const { t } = useTranslation();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 grid grid-rows-[auto_1fr_auto] reset-transform">
      {/* Favicon dynamique */}

      {/* Skip Links pour la navigation au clavier */}
      <SkipLink href="#main-content">Aller au contenu principal</SkipLink>
      <SkipLink href="#navigation">Aller à la navigation</SkipLink>

      <Header onAuthModalOpen={() => setIsAuthModalOpen(true)} />

      <main
        id="main-content"
        className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12"
      >
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-6 sm:mb-8 lg:mb-12">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 dark:text-gray-100 mb-3 sm:mb-4 lg:mb-6 leading-tight">
              {t('header.title')}
            </h1>
            <p className="text-base sm:text-lg lg:text-xl xl:text-2xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto leading-relaxed">
              {t('header.subtitle')}
            </p>
          </div>

          {/* Content */}
          <SummaryForm />
        </div>
      </main>
      <Footer />

      {/* Modal d'authentification */}
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </div>
  );
}

function App() {
  return (
    <PasswordProtection>
      <AuthProvider>
        <ToastProvider>
          <AppContent />
        </ToastProvider>
      </AuthProvider>
    </PasswordProtection>
  );
}

export default App;
